import axios from "axios";
import store from "../index";

const state = {
    measures:[]
};

const getters = {
    getMeasures: state => {
        return state.measures;
    },

};

const actions = {

    asyncFetchData : async(context,payload) => {

        let url = "measures";
        return axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },payload)
            .then(success => {
                //console.log(success.data)

                if(success.status===201){

                    context.commit('setMeasures',success.data);

                }
                return success

            }).
            catch(error => {

                return  error.response
            });


    },

};

const mutations = {
    setMeasures: (state,value) => {
        state.measures= value;
    },
};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
